import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import {
    Form,
    FloatingLabel,
    Modal
} from "react-bootstrap";

import Utils from "../../../../../Utils";
import ContextComponent from "../../../../../AppContext";

const EditSectionPage = ({ props }) => {
    const { siteid } = useParams();
    let [currSiteId, setCurrSiteId] = useState(siteid);

    let { setAlert, setLoadingState, setCanRedirectToLogin } = useContext(ContextComponent);
    let tableData = props?.tableData || [];
    let setTableData = props?.setTableData || (() => { });

    let editableSection = props?.editableSection || {};
    let editableSectionIndex = props?.editableSectionIndex || {};

    let [name, setName] = useState(editableSection?.name || "");
    let [description, setDescription] = useState(editableSection?.description || "");
    let [sectionColor, setSectionColor] = useState(editableSection?.sectionColor || "");
    let [sectionTextColor, setSectionTextColor] = useState(editableSection?.sectionTextColor || "");
    let [sectionQuestionColor, setSectionQuestionColor] = useState(editableSection?.sectionQuestionColor || "");

    const hideModal = (e) => {
        props.setEditModalCanOpen(false);
    };

    const nameHandler = (e) => {
        setName(e.currentTarget.value);
    };

    const descriptionHandler = (e) => {
        setDescription(e.currentTarget.value);
    };

    const sectionColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionColor(val);
        let logoEle1 = document.getElementById("sectionColor1");
        logoEle1.value = val;
    };

    const sectionInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionColor(val);
        let logoEle = document.getElementById("sectionColor");
        logoEle.value = val;
    };

    const sectionTextColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionTextColor(val);
        let logoEle1 = document.getElementById("sectionTextColor1");
        logoEle1.value = val;
    };

    const sectionTextInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionTextColor(val);
        let logoEle = document.getElementById("sectionTextColor");
        logoEle.value = val;
    };

    const sectionQuestionColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionQuestionColor(val);
        let logoEle1 = document.getElementById("sectionQuestionColor1");
        logoEle1.value = val;
    };

    const sectionQuestionInputColorHandler = (e) => {
        let val = e.currentTarget.value;
        setSectionQuestionColor(val);
        let logoEle = document.getElementById("sectionQuestionColor");
        logoEle.value = val;
    };

    const updateSection = (e) => {
        setLoadingState({
            applyMask: true,
            text: "Updating Section",
        });

        const success = (res) => {
            hideModal();
            setLoadingState({
                applyMask: false
            });
            setAlert({
                show: true,
                message: res?.data?.message
                    ? res.data.message
                    : "Section updated successfully!",
                type: "success",
            });

            props.loadFreshSections(currSiteId);
        };

        const fail = (err) => {
            setLoadingState({
                applyMask: false
            });
            if (err?.redirect) {
                setCanRedirectToLogin(true);
            }
            setAlert({
                show: true,
                message: err?.data?.message
                    ? err.data.message
                    : "Section update failed",
                type: "danger",
            });
            console.log(err);
        };

        let sectionInfoFormData = {
            name,
            description,
            sectionColor,
            sectionTextColor,
            sectionQuestionColor,
        };

        console.log(sectionInfoFormData);
        try {
            // debugger;
            // console.log(formData);
            Utils.updateSection(editableSection?.id, sectionInfoFormData).then(success, fail);
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => { }, [props.editModalCanOpen]);

    const handleClose = (e) => {
        props.setEditModalCanOpen(false);
    };


    return (
        <>
            <Modal centered show={props.editModalCanOpen} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{props?.siteName ? `Edit ${name} Section of ${props.siteName} site` : "Edit Section"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="indi-add-form-wrapper d-flex flex-column">
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Section Name">
                                        <Form.Control
                                            type="text"
                                            className="indi-input-field"
                                            id="name"
                                            placeholder="Enter Section Name"
                                            autoComplete="off"
                                            onChange={nameHandler}
                                            defaultValue={name}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <FloatingLabel label="Description">
                                        <Form.Control
                                            as="textarea"
                                            className="indi-input-field"
                                            id="description"
                                            placeholder="Enter Section description"
                                            autoComplete="off"
                                            onChange={descriptionHandler}
                                            defaultValue={description}
                                        />
                                    </FloatingLabel>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <div className="col-10">
                                        <FloatingLabel label="Section Color">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="sectionColor"
                                                placeholder=""
                                                autoComplete="off"
                                                onChange={sectionColorHandler}
                                                defaultValue={sectionColor}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="col">
                                        <Form.Control
                                            type="color"
                                            className="indi-input-field indi-color-input-field"
                                            id="sectionColor1"
                                            placeholder=""
                                            autoComplete="off"
                                            onChange={sectionInputColorHandler}
                                            defaultValue={sectionColor}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <div className="col-10">
                                        <FloatingLabel label="Section Text Color">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="sectionTextColor"
                                                placeholder=""
                                                autoComplete="off"
                                                onChange={sectionTextColorHandler}
                                                defaultValue={sectionTextColor}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="col">
                                        <Form.Control
                                            type="color"
                                            className="indi-input-field indi-color-input-field"
                                            id="sectionTextColor1"
                                            placeholder=""
                                            autoComplete="off"
                                            onChange={sectionTextInputColorHandler}
                                            defaultValue={sectionTextColor}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="indi-add-form-item d-flex flex-column">
                                <div className="indi-add-form-item-input row">
                                    <div className="col-10">
                                        <FloatingLabel label="Section Text Color">
                                            <Form.Control
                                                type="text"
                                                className="indi-input-field"
                                                id="sectionQuestionColor"
                                                placeholder=""
                                                autoComplete="off"
                                                onChange={sectionQuestionColorHandler}
                                                defaultValue={sectionQuestionColor}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    <div className="col">
                                        <Form.Control
                                            type="color"
                                            className="indi-input-field indi-color-input-field"
                                            id="sectionQuestionColor1"
                                            placeholder=""
                                            autoComplete="off"
                                            onChange={sectionQuestionInputColorHandler}
                                            defaultValue={sectionQuestionColor}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="indi-add-footer">
                            <div className="indi-add-page-footer-btn-wrapper float-right">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={hideModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={updateSection}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
            </Modal >
        </>
    );
}

export default EditSectionPage;